import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { DocumentHead } from 'remote-com-shared/components/DocumentHead';
import { EditingNote } from 'remote-com-shared/components/EditingNote/EditingNote';
import { Hero } from 'remote-com-shared/components/Hero';
import { getEditLink } from 'remote-com-shared/domains/contentful/helpers';
import { getDocumentFromSEOMetadata } from 'remote-com-shared/domains/contentful/prismicBridge';
import { toLocaleDateString } from 'remote-com-shared/style/helpers';
import smoothscroll from 'smoothscroll-polyfill';

import { HeadingSection, HeadingSectionWrapper } from '@/src/components/NotionPage/HeadingSection';

if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}

export function DisclaimerView({ locale, pageProps }) {
  const {
    sys: { updatedAt },
    fields: { title, lastUpdatedDateLabel = 'Last update on {date}', content },
  } = pageProps;

  const lastUpdatedDate = toLocaleDateString(updatedAt, locale);

  return (
    <>
      <DocumentHead document={getDocumentFromSEOMetadata(pageProps)} />
      <Hero
        title={title}
        description={lastUpdatedDateLabel.replace('{date}', lastUpdatedDate)}
        preview="40vh"
      />
      <EditingNote>
        <p>
          Edit this page in <a href={getEditLink(pageProps)}>Contentful</a>
        </p>
        <ul>
          <li>
            The hero title comes from the <strong>Title</strong> field
          </li>
          <li>
            The &ldquo;Last updated&rdquo; date is automatically set from the date of last publish
          </li>
          <li>
            The content below comes from the <strong>Content</strong> field
          </li>
        </ul>
      </EditingNote>
      <HeadingSectionWrapper>
        <HeadingSection>{documentToReactComponents(content)}</HeadingSection>
      </HeadingSectionWrapper>
    </>
  );
}
